import React, { useState } from "react";
import Typography from "../../../Typography";

let Services = [
  {
    name: "Realistic tattoo",
    icon: "./imgs/service/1.webp",
    description:
      "A realistic tattoo (realism or photorealism) on your body will look like a photo or a living 3D object. For an artist to reach the level of skill to paint skin with this technique, it takes years of practice and extremely high quality equipment. These tattoos are precise, full of detail, and fairly accurate representations of any motif. They are mainly used to represent faces, animals, mythological motifs, but they are by no means limited to these motifs. Realistic tattoo is mainly reduced to black and gray color in order to achieve a large number of details.",
  },
  {
    name: "Realistic color",
    icon: "./imgs/service/2.webp",
    description:
      "Tattoos made using the color realism technique require enormous knowledge and talent of the artist. In addition, they require more time and concentration to make the tattoo almost live on your skin. The best examples of tattoos in this technique seem so realistic that others feel the need to touch it, to make sure that they will feel the skin, and not the texture that the tattoo represents. This technique uses all colors, and extremely talented artists are able to evoke qualities that are not strictly visual, such as humidity, cobwebs, hair density, and many others.",
  },
  {
    name: "Realistic color",
    icon: "./imgs/service/3.webp",
    description:
      "The watercolor technique of tattooing is a relatively new technique that is becoming more and more popular over time. What worries people the most is whether this kind of tattoo will fade faster, because lighter colors are used than traditional tattooing techniques, which makes the tattoo look like it was literally done in watercolor. The answer is clear, if the tattoo artist makes sure that the tattoo has a good base, it will be very easy to renew it at any time. Also, if quality colors are used, the tattoo will not fade much faster than a darker, traditional tattoo.",
  },
  {
    name: "Neotraditional tattoo",
    icon: "./imgs/service/4.webp",
    description:
      "As the name implies, the neo-traditional tattoo is an evolution of the traditional tattoo. It retains the basic elements of a traditional tattoo such as a pronounced line and very vibrant colors, but is more illustrative than its predecessor. The main difference is that the neo-traditional tattoo has a much wider palette of colors and a wider range of motifs that are depicted. Decorative and exuberant visuals are the main features of this style, as well as the use of natural, floral and zoological motifs.",
  },
  {
    name: "Dotwork tattoo style",
    icon: "./imgs/service/5.webp",
    description:
      "The dotwork style of tattooing uses hundreds and thousands of dots, which are arranged into a larger whole (flowers, fractals, dream catcher). This style allows you to play with negative space, which means that the part of the skin not covered in ink will be part of the tattoo composition. Within this style, black is mostly used, but gray tones are also used, in order to achieve greater or lesser density of the tattoo, giving it a 'heavier' or 'lighter' appearance. This style is often used for various natural or geometric shapes, as well as in combination with other dotwork background styles.",
  },
  {
    name: "Cover up tattoo",
    icon: "./imgs/service/6.webp",
    description:
      "Cover-up is something that hardly anyone dares to do, even tattoo artists with years of experience. The reason is simple, here you need everything you've ever learned about tattooing, as well as creativity and extraordinary skill, to turn an existing tattoo into a brand new one. An existing tattoo is used as the basis for a new one, and when it's done right, you'll have something completely different than before. So, if you want - you can have a different tattoo over the existing one.",
  },
];

export default function OurServices() {
  const [openStates, setOpenStates] = useState(
    Array(Services.length).fill(false)
  );

  const toggleOpen = (index) => {
    setOpenStates((prev) => {
      const newState = [...prev];
      newState[index] = !newState[index];
      return newState;
    });
  };

  return (
    <div className="bg-[#fff] relative overflow-hidden">
      <img
        alt="pattern"
        className="h-[100%] absolute left-0 right-0 top-0 bottom-0 object-cover w-full opacity-[0.08] grayscale"
        src="./imgs/icons/pattern2.jpg"
      ></img>
      <div className="absolute left-0 right-0 bottom-0 background black-gradient h-[90px] z-10"></div>
      <div className="max-xsm:pb-[100px] max-md:pb-[150px] wrapper max-xsm:py-[50px] max-md:py-[70px] py-[100px] pb-[150px]">
        <Typography.Subt className="text-center">
          We are here to offer
        </Typography.Subt>
        <div className="max-md:mt-[40px] max-md:gap-[15px] max-md:flex-col flex flex-wrap mt-[50px]">
          {Services.map((service, index) => (
            <div
              key={index}
              className=" max-md:px-[15px] max-md:justify-between max-md:rounded-[10px] max-md:py-[10px] max-md:shadow-md max-md:bg-white max-md:w-full max-md:h-[unset] max-md:border-0 hover:z-[3] [&:nth-child(n+4)]:border-b-0 [&:nth-child(6)]:border-r-0 [&:nth-child(3)]:border-r-0 group relative Typography.Smp gap-[5px] flex flex-col items-center justify-center w-[33.33%] h-[240px] border-r-[1px] border-b-[1px] border-[solid] border-[#000]"
              onClick={() => toggleOpen(index)}
            >
              <div className="max-md:w-full max-md:justify-between max-md:gap-[15px] max-md:flex-row max-md:items-center gap-[5px] flex flex-col">
                <div className="max-md:gap-[10px] max-md:flex-row max-md:items-center gap-[5px] flex flex-col">
                  <div className="max-md:h-[50px] h-[100px] flex items-center justify-center">
                    <img
                      alt="service icon"
                      className="max-md:max-w-[45px] max-w-[80px]"
                      src={service.icon}
                    />
                  </div>
                  <Typography.BoxName className="max-md:text-left text-center">
                    {service.name}
                  </Typography.BoxName>
                </div>
                <img
                  className={`md:hidden duration-300 ${
                    openStates[index] ? "rotate-180" : "rotate-0"
                  }`}
                  src="./imgs/icons/arrow-down.svg"
                  alt="Arrow down"
                />
              </div>
              <div
                className={`max-md:p-0 max-md:opacity-100 max-md:group-hover:scale-100 max-md:relative flex justify-center items-center opacity-0 scale-100 p-[10px] group-hover:opacity-100 group-hover:scale-105 duration-300 absolute left-0 right-0 top-0 bottom-0 bg-white ${
                  openStates[index] ? "max-md:flex" : "max-md:hidden"
                }`}
              >
                <Typography.Smp className="max-md:text-left max-md:text-[12px] max-lg:text-[10px] max-2xl:text-[12px] text-center opacity-70">
                  {service.description}
                </Typography.Smp>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
